import { RefObject, useEffect, useRef } from 'react';

export function useMountedState(): RefObject<boolean> {
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
}
